module.exports = {
  apiHost: "https://api.northharbour.sensoreal.app",
  assetsHost: "https://assets.northharbour.sensoreal.app",
  brandName: "North Harbour",
  header: {
    text: { en: "Your North Harbour Selections" },
    logo:
      "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/northharbour/North%20Harbour_Logo_Stacked.png",
    logoMaxWidth: "150px",
    logoMaxHeight: "70px",
    titleFontSize: "26px",
    // companyLogo:
    //   "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/northharbour/Port-Binnli-White-Logo.png",
    color: "#F9F7F0", // coastal white
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#0f3d60 ",
    textColor: "#F9F7F0",
    font: "Arial",
    secondaryFont: "Hanken Grotesk Light",
  },
  contact: {
    website: "https://www.northharbour.com.au",
    address: "Corner Buckley Road & Fraser Drive, Burpengary East",
    phone: "07 5433 1111",
    email: "info@northharbour.com.au",
  },
  links: {
    privacy: "",
    youtube: "https://www.youtube.com/channel/UC40CqLTRfAuDdG8Q8j6JCxA",
    linkedin: "",
    twitter: "",
    instagram: "https://www.instagram.com/northharbourliving",
    facebook: "https://www.facebook.com/northharbour/",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/northharbour/Port-Binnli-White-Logo.png",
  footerLogoPosition: "bottom",
  footerLogoMaxWidth: "100px",
};
